import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import logo from '../../../images/header-logo.png';
import wordmark from '../../../images/wordmark.png';
import './style.css';
import { connect } from 'react-redux';
import { load } from './ducks/actions';
class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideMobileNav: true
    };
    this.toggleMobileNav = this.toggleMobileNav.bind(this);
    this.props.actions.load();
  }
  toggleMobileNav() {
    this.setState({
      hideMobileNav: !this.state.hideMobileNav
    });
  }
  z;
  render() {
    var hideNav = this.state.hideMobileNav ? ` navmenu-offcanvas` : ``;
    return (
      <div>
        <div className={'navmenu navmenu-zinverse' + hideNav}>
          <ul className="nav navmenu-nav">
            <li>
              <NavLink to="/paystubs" activeClassName="active">
                Paystubs
              </NavLink>
            </li>
            <li>
              <NavLink to="/taxes" activeClassName="active">
                W-2
              </NavLink>
            </li>
            <li>
              <NavLink to="/f1095c" activeClassName="active">
                1095-C
              </NavLink>
            </li>
            <li>
              <NavLink to="/account" activeClassName="active">
                My Account
              </NavLink>
            </li>
            <li>
              <NavLink to="/logout" activeClassName="active">
                Logout
              </NavLink>
            </li>
            <li>
              <img src={wordmark} alt="ComputerEase" />
            </li>
          </ul>
        </div>

        <Navbar fluid>
          <Navbar.Header>
            <div className="navbar-toggle" onClick={this.toggleMobileNav}>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </div>
            <Navbar.Brand>
              <img src={logo} alt="CE" />&nbsp;&nbsp;| {this.props.company}
            </Navbar.Brand>
          </Navbar.Header>
        </Navbar>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    company: state.navReducer.company
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      load: () => {
        dispatch(load());
      }
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Nav);



// WEBPACK FOOTER //
// ./src/components/common/Nav/index.js